import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { Grid } from '@material-ui/core';
import React from 'react';
import ResponsavelFrete from '../enums/ResponsavelFrete';

const VisualizarDadosEntrega = ({ venda, getCurrency }) => {
  const getTipoDesconto = (venda) => {
    switch (venda?.tipoDesconto) {
      case 'VALOR':
        return 'Valor';
      case 'PERCENTUAL':
        return 'Percentual';
      default:
        return '';
    }
  };

  const getMunicipioIncidencia = (municipioIncidencia) => {
    switch (municipioIncidencia) {
      case 'TOMADOR':
        return 'Tomador';
      case 'PRESTADOR':
        return 'Prestador';
      default:
        return '-';
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="municipioIncidencia"
            label="Município da incidência"
            value={getMunicipioIncidencia(venda?.municipioIncidencia)}
          />
        </Grid>
        <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
          <TextLabel
            id="valorFrete"
            label="Frete a cobrar do cliente (R$)"
            value={venda?.valorFrete ? getCurrency(venda?.valorFrete).replace('R$', '') : ''}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel id="tipoDesconto" label="Tipo de desconto" value={getTipoDesconto(venda)} />
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <TextLabel
            id="valorDesconto"
            label="Desconto"
            value={venda?.valorDesconto ? getCurrency(venda?.valorDesconto).replace('R$', '') : ''}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="valorTotal"
            label="Valor total (R$)"
            value={venda?.valorTotal ? getCurrency(venda?.valorTotal).replace('R$', '') : ''}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} className="mb-16">
        <Grid item xs={5}>
          <TextLabel
            id="responsavelFrete"
            label="Responsável pelo frete"
            value={ResponsavelFrete[venda?.responsavelFrete]}
          />
        </Grid>
        <Grid item xs={5}>
          <TextLabel id="transportadora" label="Transportadora" value={venda?.transportadora?.pessoa?.nome} />
        </Grid>
        <Grid item xs={5}>
          <DateLabel id="previsaoEntrega" label="Previsão de entrega" value={venda?.previsaoEntrega} />
        </Grid>
        {venda?.situacao === 'EM_ORCAMENTO' && (
          <Grid item xs={5}>
            <DateLabel
              id="dataVencimentoOrcamento"
              label="Proposta válida até"
              value={venda?.dataVencimentoOrcamento}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default VisualizarDadosEntrega;
